/**
 * Well & Proof — Shopify Cart Bridge
 * Uses a normal /cart/add form post. JSON /cart/add.js is blocked by
 * Shopify bot protection after repeated clicks ("Please try again in a few minutes").
 */
(function (global) {
  'use strict';

  var routes = (global.WellProofShop && global.WellProofShop.routes) || {};

  function formatPrice(cents) {
    var amount = (cents || 0) / 100;
    return '₹' + amount.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function updateCartUI(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.setAttribute('aria-label', count + ' items in cart');
    });
  }

  function showToast(message) {
    var toast = document.getElementById('cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cart-toast';
      toast.className = 'cart-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('cart-toast--visible');
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(function () {
      toast.classList.remove('cart-toast--visible');
    }, message && message.length > 60 ? 7000 : 3200);
  }

  function cartAddUrl(goCheckout) {
    var base = (routes && routes.cartAdd) || '/cart/add';
    if (goCheckout) {
      return base + (base.indexOf('?') === -1 ? '?' : '&') + 'return_to=/checkout';
    }
    return base;
  }

  function addToCart(variantId, qty, productName, goCheckout) {
    var id = parseInt(variantId, 10);
    if (!id) {
      showToast('This product is not connected. Open Theme settings → Products, choose Laxiva and Detoxa, then save.');
      return Promise.reject(new Error('Missing variant'));
    }

    var form = document.createElement('form');
    form.method = 'post';
    form.action = cartAddUrl(goCheckout);
    form.acceptCharset = 'UTF-8';
    form.style.display = 'none';

    function hidden(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value);
      form.appendChild(input);
    }

    hidden('id', id);
    hidden('quantity', qty || 1);
    if (goCheckout) hidden('return_to', '/checkout');

    document.body.appendChild(form);
    form.submit();
    return Promise.resolve();
  }

  function initQuickViewShopify() {
    var modalAddCart = document.getElementById('modal-add-cart');
    if (!modalAddCart || modalAddCart.getAttribute('data-shopify-bound')) return;
    modalAddCart.setAttribute('data-shopify-bound', 'true');

    modalAddCart.addEventListener('click', function () {
      var variantId = modalAddCart.getAttribute('data-variant-id');
      var productName = modalAddCart.getAttribute('data-product-name') || 'Product';
      if (!variantId) {
        var key = modalAddCart.getAttribute('data-product-id');
        var catalog = global.WellProofShop && global.WellProofShop.catalog;
        if (key && catalog && catalog[key] && catalog[key].variantId) {
          variantId = catalog[key].variantId;
        }
      }
      if (!variantId) {
        showToast('Connect this product in Theme settings → Products, then save.');
        return;
      }
      addToCart(variantId, 1, productName);
    });
  }

  function submitCartUpdate(input) {
    var form = input && input.closest('form');
    if (!form) return;
    var update = form.querySelector('button[name="update"]');
    if (update) {
      update.click();
      return;
    }
    form.submit();
  }

  function initCartQty() {
    var form = document.getElementById('cart-form');
    if (!form || form.getAttribute('data-qty-bound')) return;
    form.setAttribute('data-qty-bound', 'true');

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var wrap = btn.closest('.cart-item__qty');
      var input = wrap && wrap.querySelector('.qty-input');
      if (!input) return;
      var delta = parseInt(btn.getAttribute('data-qty-change'), 10) || 0;
      var next = Math.max(0, Math.min(99, (parseInt(input.value, 10) || 1) + delta));
      input.value = next;
      submitCartUpdate(input);
    });

    form.addEventListener('change', function (e) {
      if (!e.target.classList.contains('qty-input')) return;
      var next = parseInt(e.target.value, 10);
      if (isNaN(next) || next < 0) next = 0;
      e.target.value = Math.min(99, next);
      submitCartUpdate(e.target);
    });
  }

  function init() {
    if (global.WellProofShop && typeof global.WellProofShop.cartItemCount === 'number') {
      updateCartUI(global.WellProofShop.cartItemCount);
    }
    initQuickViewShopify();
    initCartQty();
  }

  global.WellProofShopifyCart = {
    addToCart: addToCart,
    formatPrice: formatPrice,
    updateCartUI: updateCartUI,
    showToast: showToast,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
